<div class="relative">
  <div class="w-full h-64 bg-cover bg-center" style="background-image: url('/assets/contact/contact-gradient.png')">
    <div class="absolute inset-0 bg-black bg-opacity-40">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full flex items-center justify-center">
        <img [src]="'/assets/contact/ms-sencha.png'|imageModifier:{width:240}|async" alt="Oolong Lady" class="h-48 object-contain">
      </div>
    </div>
  </div>
</div>

<div class="relative min-h-screen">
  <div class="absolute inset-0">
    <div class="h-1/2 bg-white relative">
      <img [src]="'/assets/contact/left-leaf.png'|imageModifier:{width:230}|async" alt="" class="absolute top-0 left-0 h-48 object-contain">
      <img [src]="'/assets/contact/left-leaf.png'|imageModifier:{width:230}|async" alt="" class="absolute top-0 right-0 h-48 object-contain scale-x-[-1]">
    </div>
    <div class="h-1/2 bg-gray-100"></div>
  </div>

  <div class="relative py-12 px-4 sm:px-6 lg:px-8">
    <div class="max-w-md mx-auto bg-white rounded-lg shadow-lg p-8">
      <h2 class="text-3xl font-semibold text-gray-800 text-center mb-8">Contact Us</h2>
      <p class="text-gray-600 text-center mb-8">We'd love to hear from you. Please fill out this form.</p>

      <form [formGroup]="contactForm" (ngSubmit)="onSubmit()" class="space-y-6">
        <div>
          <label for="name" class="block text-sm font-medium text-gray-700">Name</label>
          <input type="text" id="name" formControlName="name"
            class="mt-1 block w-full rounded-md border-gray-300 border-2 shadow-sm focus:border-green-500 focus:ring-4 focus:ring-green-200 focus:ring-opacity-50 px-3 py-2">
          @if (submitted && contactForm.get('name')?.errors) {
            <div class="text-red-500 text-sm mt-1">
              Please enter your name
            </div>
          }
        </div>

        <div>
          <label for="email" class="block text-sm font-medium text-gray-700">Email</label>
          <input type="email" id="email" formControlName="email"
            class="mt-1 block w-full rounded-md border-gray-300 border-2 shadow-sm focus:border-green-500 focus:ring-4 focus:ring-green-200 focus:ring-opacity-50 px-3 py-2">
          @if (submitted && contactForm.get('email')?.errors) {
            <div class="text-red-500 text-sm mt-1">
              Please enter a valid email address
            </div>
          }
        </div>

        <div>
          <label for="subject" class="block text-sm font-medium text-gray-700">Subject</label>
          <select id="subject" formControlName="subject"
            class="mt-1 block w-full rounded-md border-gray-300 border-2 shadow-sm focus:border-green-500 focus:ring-4 focus:ring-green-200 focus:ring-opacity-50 px-3 py-2">
            <option value="">-- Select a subject --</option>
            @for (subject of subjects; track subject) {
              <option [value]="subject.value">
                {{subject.label}}
              </option>
            }
          </select>
          @if (submitted && contactForm.get('subject')?.errors; as errors) {
            <div class="text-red-500 text-sm mt-1">
              @if (errors['required']) {
                <span>Please select a subject</span>
              }
              @if (errors['invalidSubject']) {
                <span>Please select a valid subject</span>
              }
            </div>
          }
        </div>

        <div>
          <label for="message" class="block text-sm font-medium text-gray-700">Message</label>
          <textarea id="message" rows="4" formControlName="message"
          class="mt-1 block w-full rounded-md border-gray-300 border-2 shadow-sm focus:border-green-500 focus:ring-4 focus:ring-green-200 focus:ring-opacity-50 px-3 py-2"></textarea>
          @if (submitted && contactForm.get('message')?.errors) {
            <div class="text-red-500 text-sm mt-1">
              Please enter your message
            </div>
          }
        </div>

        <div>
          <button type="submit"
            class="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-green-800 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500">
            Send Message
          </button>
        </div>

        <div class="flex justify-center mt-8">
          <!-- <img src="/assets/contact/sencha-logo.png" alt="Sencha Logo" class="h-16 object-contain"> -->
        </div>
      </form>
    </div>
  </div>
</div>
